/* eslint semi:0 */
import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const CLASS_CONSTATNTS = namespacedConsts({
  NAVBAR: {
    ACTIONS: {
      REACHED_COVER_SOCIAL_COMPONENT: true,
      REACHED_POST_TITLE: true,
      NAVBAR_MOBILE_SHARE_ACTION: true,
    },
  },
})

export const TYPES = CLASS_CONSTATNTS.NAVBAR.ACTIONS

export function socialComponentScrollerReached(scrollingEventObject) {
  appDispatcher.dispatchAction.view({
    type: TYPES.REACHED_COVER_SOCIAL_COMPONENT,
    payload: {
      scrollingEventObject,
      isInViewport: scrollingEventObject,
    },
    dispatchToRedux: true,
  })
}

export function titleScrollerReached(scrollingEventObject) {
  appDispatcher.dispatchAction.view({
    type: TYPES.REACHED_POST_TITLE,
    payload: {
      scrollingEventObject,
      isInViewport: scrollingEventObject,
    },
    dispatchToRedux: true,
  })
}

export function navbarMobileShare(mobileShareButtonsList) {
  appDispatcher.dispatchAction.view({
    type: TYPES.NAVBAR_MOBILE_SHARE_ACTION,
    mobileShareButtonsList,
  })
}

export function navbarMobileMessageShare() {
  appDispatcher.dispatchAction.view({
    type: TYPES.NAVBAR_MOBILE_SHARE_ACTION,
  })
}

export function navbarMobileGooglePlusShare() {
  appDispatcher.dispatchAction.view({
    type: TYPES.NAVBAR_MOBILE_SHARE_ACTION,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/navbarActions.js